var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mt-filters"},[_c('filters-item',{attrs:{"filter":_vm.statusFilter},on:{"toggle-show":_vm.toggleShow,"change-handler":_vm.statusChangeHandler}}),_vm._l((_vm.filledFilters),function(filter){return _c('filters-item',{key:filter.id,attrs:{"filter":filter},on:{"change-handler":_vm.changeHandler,"toggle-show":_vm.toggleShow}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }